import { All_NOTIFICATIONS } from './actionTypes';
import * as queries from '../../graphql/queries';
import { updateNotifications } from '../../graphql/mutations';
import axios from "axios";
import fetchItemsNextToken from '../../graphql/fetchItemsNextToken';
import {  API, graphqlOperation } from 'aws-amplify';


export const notificationsAction = {
  allNotifications,
  updateNotificationsItems
};


function allNotifications() {
  return async(dispatch) => {
    
    dispatch({type : All_NOTIFICATIONS,notifications:[]})
    let newUserID=localStorage.getItem('userDetailsID');

    // Doing this because userDetailsID is not set in localstorage most of the times after a register.
    if(!newUserID) {
      // console.log("newUserID is not set and is null", newUserID)
      const userMasterData = await API.graphql(graphqlOperation(queries.getUserMaster, { id: localStorage.getItem('userID') }))
        // console.log("Fetched user master data in notifications", userMasterData)
        
        const userProfileData = await API.graphql(graphqlOperation(queries.getUserProfileDetails, { id: userMasterData.data.getUserMaster.UserProfileDetails.items[0].id }))
        // console.log("Fetched userProfileData in notifications", userProfileData.data.getUserProfileDetails)
        newUserID = userProfileData.data.getUserProfileDetails.id
    }

  
    let userData=await getUserNotificationList(newUserID);
    if(userData.length>0)
    {
      console.log('NotificationList userData',userData);
      dispatch({type : All_NOTIFICATIONS,notifications:userData});
    }
    
  
    //dispatch({type : All_CONNECTIONS,filterConnectionData:userData});
  };
  async function getUserNotificationList(userID)
  {
    
    let userData = await API.graphql(graphqlOperation(queries.getUserProfileDetails, { id: userID }));
    let newData = userData.data.getUserProfileDetails;
    if(newData)
    {
      return newData.notifications.items.sort((a, b) => b.createdAt.localeCompare(a.createdAt))
    }
    else
    {
      return false;
    }

  }
}

function updateNotificationsItems(notificationList) {
  return async(dispatch) => {
    
    
    let newUserID=localStorage.getItem('userDetailsID');
    for (let i = 0; i < notificationList.length; i++) {
      const element = notificationList[i];
      if(element.read===0)
      {
        await updateNotificationList(element.id);
        //await dispatch(notificationsAction.allNotifications());
      }
    }
  };
  async function getUserNotificationList(userID)
  {
    

    let userData = await API.graphql(graphqlOperation(queries.getUserProfileDetails, { id: userID }));
    let newData = userData.data.getUserProfileDetails;
    if(newData)
    {
      return newData.notifications.items.sort((a, b) => b.createdAt.localeCompare(a.createdAt))
    }
    else
    {
      return false;
    }
  }
  async function updateNotificationList(id)
  {

    const userUpdateData = { 'id':id, 'read': 1 };
    let userUpdate=await API.graphql(graphqlOperation(updateNotifications, { input: userUpdateData }));
    if(userUpdate.data.updateNotifications)
    {
      return true
    }
    else
    {
      return false
    }

      
  }
}
